import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const skeletonBaseColor = '#eee';
const skeletonHighlightColor = '#f5f5f5';

const skeletonKeyframes = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;
interface ISkeletonProps {
  flex?: boolean;
}
export const SkeletonFrame = styled.span<ISkeletonProps>`
  background-color: ${skeletonBaseColor};
  background-image: linear-gradient(
    90deg,
    ${skeletonBaseColor},
    ${skeletonHighlightColor},
    ${skeletonBaseColor}
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  line-height: 1;
  width: 100%;
  animation: ${skeletonKeyframes} 1.2s ease-in-out infinite;
  display: inline-block;
  ${p =>
    p.flex &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  @media (prefers-reduced-motion) {
    animation: none;
  }
`;
export const MediaIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#8b8b8b"
  >
    <path d="M9 12c0-.552.448-1 1.001-1s.999.448.999 1-.446 1-.999 1-1.001-.448-1.001-1zm6.2 0l-1.7 2.6-1.3-1.6-3.2 4h10l-3.8-5zm5.8-7v-2h-21v15h2v-13h19zm3 2v14h-20v-14h20zm-2 2h-16v10h16v-10z" />
  </svg>
);
